import { scrollLock, escListener } from './utils'

const lightboxEl = document.querySelector('.pdp-lightbox')
const closeButton = lightboxEl.querySelector('.pdp-lightbox__close')
const videos = lightboxEl.querySelectorAll('video')

const jumpToTargetFigure = (index) => {
  if (index > 0) {
    lightboxEl.scrollTop =
      lightboxEl.querySelectorAll('figure')[index].offsetTop +
      parseInt(getComputedStyle(lightboxEl).paddingTop)
  } else {
    lightboxEl.scrollTop = 0
  }
}

const openLightBox = (index) => {
  console.log('openLightbox')

  scrollLock(true)
  escListener(true, closeLightBox)
  lightboxEl.classList.add('pdp-lightbox--open')

  jumpToTargetFigure(index)
}

const closeLightBox = () => {
  scrollLock(false)
  escListener(false)
  lightboxEl.classList.remove('pdp-lightbox--open')

  videos.forEach((video) => {
    video.pause()
  })
}

closeButton.addEventListener('click', () => {
  closeLightBox()
})

lightboxEl.querySelectorAll('figure').forEach((image) => {
  let desktop = window.matchMedia('(min-width: 1025px)')
  if (desktop.matches) {
    image.addEventListener('click', closeLightBox)
  }
})

document
  .querySelectorAll('.product-converter__thumbnails figure')
  .forEach((figure, index) => {
    figure.addEventListener('click', () => {
      openLightBox(index)
    })
  })

window.addEventListener('load', function () {
  if (!document.querySelector('.product-converter__thumbnails').swiper) {
    document
      .querySelectorAll('.product-converter__thumbnails figure')
      .forEach((figure, index) => {
        figure.addEventListener('click', () => {
          openLightBox(index)
        })
      })
  }
})

function isElementOutViewport(el) {
  var rect = el.getBoundingClientRect()
  return (
    rect.bottom < 0 ||
    rect.right < 0 ||
    rect.left > window.innerWidth ||
    rect.top > window.innerHeight
  )
}
const checkVideos = () => {
  videos.forEach((video) => {
    if (isElementOutViewport(video)) {
      video.pause()
    } else {
      video.play()
    }
  })
}

lightboxEl.addEventListener('scroll', checkVideos)

export { openLightBox }
